import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('tomat-search', {params});
    },

    detailStock(params) {
        return Service().get(`tomat-search/detail-stock`, {params});
    },

    detailSmartcat(params) {
        return Service().get(`tomat-search/detail-smartcat`, {params});
    },

    detailTomatV2(material_number, plant) {
        return Service().get(`tomat-search/detail-tomat-v2`, { params: { material_number, plant } });
    },

    getPlant() {
        return Service().get('tomat-search/list-plant');
    },
}